import { render } from "./SpecialProCategory.vue?vue&type=template&id=030fd870&scoped=true"
import script from "./SpecialProCategory.vue?vue&type=script&lang=ts"
export * from "./SpecialProCategory.vue?vue&type=script&lang=ts"

import "./SpecialProCategory.vue?vue&type=style&index=0&id=030fd870&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-030fd870"

export default script